import { render } from "./Textarea-Plus-Two.vue?vue&type=template&id=d3803526&scoped=true"
import script from "./Textarea-Plus-Two.vue?vue&type=script&lang=js"
export * from "./Textarea-Plus-Two.vue?vue&type=script&lang=js"

import "./Textarea-Plus-Two.vue?vue&type=style&index=0&id=d3803526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3803526"]])

export default __exports__